





























































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { HTデータ取込対象型 } from '@/type/purchaseorder/item';
import {
  ハンディ入庫検索依頼型,
  ハンディ入庫レコード型,
  ハンディ入庫取込レコード型,
  ハンディ入庫取込依頼型,
  未確定入庫一覧取得依頼型, 入庫入力型,
} from '@/type/stock/receive/unfixed';
import { progress } from '@/script/progress';
import { loginModule } from '@/store/authentication/login';
import NormalDialog from '@/components/atom/dialog/NormalDialog.vue';
import moment from 'moment';
import api from '@/infrastructure/api/api';

@Component({
  filters: {
    採用区分を表示(採用区分: string): string | null {
      return (採用区分 === '採用品') ? '採用品' : '';
    },
  },
  components: {
    NormalDialog,
  },
})

export default class HandyStockImportDialog extends Vue {
  private ハンディ入庫検索条件: ハンディ入庫検索依頼型 = this.検索条件初期値を取得();
  private ハンディ入庫取込対象リスト: ハンディ入庫レコード型[] = [];

  @Prop({default: false})
  private modal!: boolean;

  @Prop({ default: []})
  private deviceList!: HTデータ取込対象型[];

  @Prop({ default: []})
  private departmentCode!: string;

  private async 確定するハンドラ() {
      await progress(this.確定する);
  }

  private async 確定する(): Promise<void> {
    if (this.ハンディ入庫取込対象リスト.length === 0) {
      this.$emit('show-alert', '取込対象の入庫がありません');
      return;
    }

    const 取込対象リスト: ハンディ入庫取込レコード型[] = this.ハンディ入庫取込対象リスト
      .map((取得対象: ハンディ入庫レコード型) => {
        return {
          ハンディ入庫SEQ: 取得対象.ハンディ入庫SEQ,
          更新バージョン: 取得対象.更新バージョン,
        };
      });

    const ハンディ入庫取込依頼: ハンディ入庫取込依頼型 = {
      ハンディ入庫取込レコード一覧: 取込対象リスト,
    };

    await api.ハンディ入庫を取り込む(ハンディ入庫取込依頼)
        .then((response: number[]) => {
          const ハンディ入庫取込結果 = response;
          const 未確定入庫一覧取得依頼: 未確定入庫一覧取得依頼型 = {
            入庫先部署コード: this.departmentCode,
            入庫SEQ一覧: ハンディ入庫取込結果,
          };
          const 取込んだ未確入庫 = this.取込んだ未確入庫を入庫入力に追加する(未確定入庫一覧取得依頼);
          this.$modal.hide('HTデータ取込画面');
          this.$emit('ok-handy-import', 取込んだ未確入庫);
        }).catch((error: any) => {
          this.$emit('show-alert', error.data.message);
        });
  }

  private async 取込んだ未確入庫を入庫入力に追加する(未確定入庫一覧取得依頼: 未確定入庫一覧取得依頼型): Promise<void> {
    await api.取込んだ未確入庫を取得する(未確定入庫一覧取得依頼)
            .then((response: 入庫入力型[]) => {
              const 確定したハンディの入庫入力一覧: 入庫入力型[] = response;
              this.addHandyItem(確定したハンディの入庫入力一覧);
            }).catch((error: any) => {
              this.$emit('show-alert', error.data.message);
            });
  }

  @Emit()
  private addHandyItem(入庫入力一覧: 入庫入力型[]) {
    return;
  }

  private 戻る() {
    this.$modal.hide('HTデータ取込画面');
    this.$emit('cancel-handy-import');
  }

  @Watch('modal')
  private ダイアログ表示状態変更(nowModal: boolean, prevModal: boolean) {
    if (nowModal === true) {
      this.ハンディ入庫取込対象リスト = [];
      this.ハンディ入庫検索条件 = this.検索条件初期値を取得();
      this.$modal.show('HTデータ取込画面');
    }
  }

  private 検索条件初期値を取得(): ハンディ入庫検索依頼型 {
    return {
      機械番号: '',
      入庫先部署コード: this.departmentCode,
    };
  }

  private async 検索するハンドラ(): Promise<void> {
    await progress(this.検索する);
  }

  private async 検索する(): Promise<void> {
    await api.ハンディ入庫を検索する(this.ハンディ入庫検索条件)
        .then((response: ハンディ入庫レコード型[]) => {
          this.ハンディ入庫取込対象リスト = response;
          if (this.ハンディ入庫取込対象リスト.length === 0) {
            this.$emit('show-alert', '取込対象の入庫が見つかりませんでした');
          }
        }).catch((error: any) => {
          this.$emit('show-alert', error.data.message);
          this.ハンディ入庫取込対象リスト = [];
        });
  }

  private get 表示件数を取得() {
    return this.ハンディ入庫取込対象リスト.length;
  }
}
